import { Button, ButtonProps } from '@doveit/lego';
import React, { FunctionComponent } from 'react';
import * as styles from './FeaturedBox.style';

export interface FeaturedBoxProps {
  caption?: string,
  title: string,
  description: string,
  cta: ButtonProps,
}

const FeaturedBox: FunctionComponent<FeaturedBoxProps> = ({
  caption,
  title,
  description,
  cta,
}) => (
  <div css={styles.base}>
    <div css={styles.content}>
      <div css={styles.box}>
        {caption && (
        <div css={styles.caption}>
          {caption}
        </div>
        )}
        <div css={styles.title}>
          {title}
        </div>
      </div>
      <div css={styles.box}>
        <div css={styles.description}>
          {description}
        </div>
        <div css={styles.action}>
          <Button {...cta} />
        </div>
      </div>
    </div>
  </div>
);

export default FeaturedBox;
